<scaffold-dialog [showCloseButton]="true" [title]="'verify_your_password' | translation" fit="true">
  <div scaffoldDialogBody>
    <div class="verify-password-form">
      <app-input
        [control]="usernameControl"
        [label]="'username' | translation"
        [placeholder]="'username' | translation"
        [disabled]="true">
      </app-input>

      <app-input
        [control]="passwordControl"
        [label]="'password' | translation"
        [placeholder]="'password' | translation"
        [hideInput]="true">
      </app-input>

      <label class="error-message app-label">
        {{ errorMessage }}
      </label>
    </div>
  </div>
  <div scaffoldDialogButtons>
    <app-button
      status="secondary"
      (click)="close()">
      {{ 'cancel' | translation }}
    </app-button>
    <app-button
      status="primary"
      (click)="verifyPassword()"
      [isProcessing]="isWorking"
      [disabled]="!passwordControl.value || isWorking">
      {{ 'verify' | translation }}
    </app-button>
  </div>
</scaffold-dialog>
